export enum LegalFormEnum {
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  NATURAL_PERSON = 'NATURAL_PERSON',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
}
